import { isPlatform } from '@ionic/react'
import React from 'react'

export const SafetyPadding = () => {
  let height = isPlatform('capacitor') ? '120px' : '160px'
  
  return (
    <div style={{'height': height}}/>
  )
}
